import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountExposureQueryKey, accountQueryKey } from "../../account/account.keys";
import { bondRequestPreviewsQueryKey, bondRequestsQueryKey } from "../bond-request.keys";

export const useAdminCreateBondRequest = () => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["adminCreateBondRequestForAccount"],
		mutationFn: async ({
			accountId,
			data,
		}: {
			accountId: SuretyAccountId;
			data: Dtos.Admin.SuretyQuote.Create.Request;
		}) => {
			return post<Dtos.Admin.Quote.Create.Response>(
				`/v2/admin/surety/accounts/${accountId}/quotes`,
				data,
			);
		},
		onSuccess: (_, { accountId }) => {
			queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey() });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId), exact: true });
			queryClient.invalidateQueries({ queryKey: accountExposureQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
		},
	});

	return {
		createBondRequest: mutation.mutateAsync,
		createBondRequestIsLoading: mutation.isPending,
	};
};
